<template>
  <Card class="study-summ-card" v-if="model">
    <p slot="title" class="clearfix">
      <Icon type="ios-stats" /> <span>研究中心、团队概况与进度概况</span>
    </p>
    <Row :gutter="10">
      <Col :span="12">
        <div class="study-summ-screen">
          <div>
            筛选受试者
          </div>
          <Tag color="primary">{{ screenNum }}</Tag>
           例
        </div>
      </Col>
      <Col :span="12" style="text-align: center;">
        <i-circle
            :trail-width="10"
            :stroke-width="10"
            :percent="progress"
            stroke-linecap="square"
            stroke-color="#2ccadf">
            <div class="circle-content">
                <p>录入进度 {{ progress }}%</p>
                <span>
                  {{ randomNum }} / {{ sample }}
                </span>
            </div>
        </i-circle>
      </Col>
    </Row>
    <Divider>中心概况</Divider>
    <Row :gutter="10">
      <Col :span="8" v-for="(type, key) in types" :key="key">
        <div class="study-summ-item">
          {{ type }} <Badge :count="getSiteNum(key)" :show-zero="true" type="info"></Badge>
        </div>
      </Col>
    </Row>
    <Divider>研究团队</Divider>
    <Row :gutter="10">
      <Col :span="8" v-for="(role, key) in roles" :key="key">
        <div class="study-summ-item">
          {{ role }} <Badge :count="getRoleNum(role)" :show-zero="true" type="info"></Badge>
        </div>
      </Col>
    </Row>
  </Card>
</template>

<script>
import { SummaryStudy } from '@/api/study'

export default {
  name: 'study-sites',
  data: function () {
    return {
      sites: [],
      types: [],
      members: [],
      roles: [],
      statuses: [],
      subjects: [],
      sample: null
    }
  },
  props: ['model'],
  created: function () {
    this.fetchData()
  },
  computed: {
    randomNum: function () {
      for (var i in this.subjects) {
        if (this.subjects[i].status === '3') {
          return this.subjects[i].num
        }
      }
      return 0
    },
    screenNum: function () {
      var num = 0
      for (var i in this.subjects) {
        num += Number(this.subjects[i].num)
      }
      return num
    },
    progress: function () {
      if (this.sample) {
        return Math.round(this.randomNum * 100 / this.sample, 2)
      }
      return 0
    }
  },
  methods: {
    fetchData: function () {
      const id = this.$route.params.id
      SummaryStudy(id).then(async res => {
        this.sites = res.sites
        this.types = res.types
        this.roles = res.roles
        this.members = res.members
        this.statuses = res.statuses
        this.subjects = res.subjects
        this.sample = res.sample
      })
    },
    getSiteNum: function (type) {
      for (var i in this.sites) {
        var site = this.sites[i]
        if (site.type === type) {
          return Number(site.num)
        }
      }
      return 0
    },
    getRoleNum: function (role) {
      for (var i in this.members) {
        var member = this.members[i]
        if (member.role === role) {
          return Number(member.num)
        }
      }
      return 0
    }
  }
}
</script>

<style>
.study-summ-item {
  padding: 8px;
  margin: 5px 0;
  width: 100%;
  border: 1px solid #dedede;
}
.study-summ-item > .ivu-badge {
  float: right;
}
.circle-content {
  font-size: .9em;
}
.circle-content > p {
  font-weight: bolder;
  padding-bottom: 5px;
}
.study-summ-screen {
  height: 100%;
  font-size: 1.8em;
  text-align: center;
  vertical-align: middle;
  padding-top: 10%;
}
</style>
